import React, { useState } from 'react'
import {
  ButtonFinance,
  ButtonFinanceWrapper, FinanceIntroCol, FinanceIntroCol4, FinanceIntroCol5,
  FinanceIntroDesc,
  FinanceIntroItem,
  FinanceIntroList,
  FinanceIntroListWrapper,
  FinanceIntroTitle,
  FinanceIntroWrapper,
  FinanceTextGradient,
  FinanceTextGradientWrapper,
} from './FinanceIntroStyled'
import {
  ButtonGradient,
  ButtonGradientWrapper,
  CampaignContentText,
  CenterDiv,
  CircleBackground,
  Container,
  TextGradient,
  TextGradientWrapper,
} from '../CommonStyled/CommonStyled'
import { Col, Modal, Row } from 'antd'
import IMAGES from '../../images'
import { useRecoilValue } from 'recoil'
import { breakPointState } from '../../recoil/commonState'
import { BREAKPOINT, PAGES, REGISTER_DETAIL_ID, REGISTER_ID, VIEW_MODE } from '../../constant'
import config from '../../config'
import ScrollHeightBase from '../ScrollHeightBase'
import DangerouslySetInnerHtml from '../DangerouslySetInnerHtml'
import { buildPath } from '../../utils/common'

const FinanceIntro = props => {
  const { financeData, mode } = props
  const breakPoint = useRecoilValue(breakPointState)
  const [openModal, setOpenModal] = useState(false)
  const [detailType, setDetailType] = useState('')

  const renderGutter = () => {
    switch (breakPoint) {
      case BREAKPOINT.LG:
      case BREAKPOINT.MD:
      case BREAKPOINT.SM:
      case BREAKPOINT.XS:
        return [16, 16]
      default:
        return [32, 32]
    }
  }

  const handleClickRegister = () => {
    switch (mode) {
      case VIEW_MODE.PREVIEW:
        window.open(`${config.basePath}${PAGES.REGISTER_PREVIEW_SME.PATH}/${REGISTER_ID.FINANCE}`, '_blank')
        break
      case VIEW_MODE.PUBLIC:
        window.open(`${config.basePath}${PAGES.REGISTER_SME.PATH}/${REGISTER_ID.FINANCE}`, '_blank')
        break
      default:
        break
    }
  }

  const renderByLength = (data) => {
    if (!data || data?.length === 0) return
    switch (data?.length) {
      case 4:
        return data.map((item, index) =>
          <FinanceIntroCol4 xxl={6} xl={12} lg={12} md={12} sm={24} xs={24} className={'centerCol'} key={index}>
            <FinanceIntroItem background={buildPath(item?.commonImage)}>
              <FinanceIntroTitle>{item?.commonTitle}</FinanceIntroTitle>
              <FinanceIntroDesc>{item?.commonDescription}</FinanceIntroDesc>
              <FinanceIntroListWrapper>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -372.51%, #23B04E 87.98%)'}>
                  {item?.description1}
                </FinanceIntroList>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -186.79%, #23B04E 273.79%)'}>
                  {item?.description2}
                </FinanceIntroList>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -0.98%, #23B04E 459.6%)'}>
                  {item?.description3}
                </FinanceIntroList>
              </FinanceIntroListWrapper>
              <ButtonFinanceWrapper>
                {/*<ButtonFinance*/}
                {/*  onClick={() => handleClickRegister(FINANCE_OPTIMIZE)}*/}
                {/*  background={'linear-gradient(90deg, #214081 -1.3%, #23B04E 393.97%)'}>*/}
                {/*  ĐĂNG KÝ NGAY*/}
                {/*</ButtonFinance>*/}
                {/*<ButtonFinance*/}
                {/*  onClick={() => handleClickViewDetail(REGISTER_DETAIL_ID.FINANCE_OPTIMIZE)}*/}
                {/*  background={'linear-gradient(90deg, #214081 -1.3%, #23B04E 393.97%)'}>*/}
                {/*  XEM CHI TIẾT*/}
                {/*</ButtonFinance>*/}
              </ButtonFinanceWrapper>
            </FinanceIntroItem>
          </FinanceIntroCol4>
        )
      case 5:
        return data.map((item, index) =>
          <FinanceIntroCol5 xxl={8} xl={8} lg={8} md={8} sm={24} xs={24} index={index} key={index}>
            <FinanceIntroItem background={buildPath(item?.commonImage)}>
              <FinanceIntroTitle>{item?.commonTitle}</FinanceIntroTitle>
              <FinanceIntroDesc>{item?.commonDescription}</FinanceIntroDesc>
              <FinanceIntroListWrapper>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -372.51%, #23B04E 87.98%)'}>
                  {item?.description1}
                </FinanceIntroList>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -186.79%, #23B04E 273.79%)'}>
                  {item?.description2}
                </FinanceIntroList>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -0.98%, #23B04E 459.6%)'}>
                  {item?.description3}
                </FinanceIntroList>
              </FinanceIntroListWrapper>
              <ButtonFinanceWrapper>
                {/*<ButtonFinance*/}
                {/*  onClick={() => handleClickRegister(FINANCE_OPTIMIZE)}*/}
                {/*  background={'linear-gradient(90deg, #214081 -1.3%, #23B04E 393.97%)'}>*/}
                {/*  ĐĂNG KÝ NGAY*/}
                {/*</ButtonFinance>*/}
                {/*<ButtonFinance*/}
                {/*  onClick={() => handleClickViewDetail(REGISTER_DETAIL_ID.FINANCE_OPTIMIZE)}*/}
                {/*  background={'linear-gradient(90deg, #214081 -1.3%, #23B04E 393.97%)'}>*/}
                {/*  XEM CHI TIẾT*/}
                {/*</ButtonFinance>*/}
              </ButtonFinanceWrapper>
            </FinanceIntroItem>
          </FinanceIntroCol5>
        )
      default:
        return data.map((item, index) =>
          <FinanceIntroCol4 xxl={6} xl={8} lg={8} md={8} sm={24} xs={24} className={'centerCol'} key={index}>
            <FinanceIntroItem background={buildPath(item?.commonImage)}>
              <FinanceIntroTitle>{item?.commonTitle}</FinanceIntroTitle>
              <FinanceIntroDesc>{item?.commonDescription}</FinanceIntroDesc>
              <FinanceIntroListWrapper>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -372.51%, #23B04E 87.98%)'}>
                  {item?.description1}
                </FinanceIntroList>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -186.79%, #23B04E 273.79%)'}>
                  {item?.description2}
                </FinanceIntroList>
                <FinanceIntroList background={'linear-gradient(0deg, #214081 -0.98%, #23B04E 459.6%)'}>
                  {item?.description3}
                </FinanceIntroList>
              </FinanceIntroListWrapper>
              <ButtonFinanceWrapper>
                {/*<ButtonFinance*/}
                {/*  onClick={() => handleClickRegister(FINANCE_OPTIMIZE)}*/}
                {/*  background={'linear-gradient(90deg, #214081 -1.3%, #23B04E 393.97%)'}>*/}
                {/*  ĐĂNG KÝ NGAY*/}
                {/*</ButtonFinance>*/}
                {/*<ButtonFinance*/}
                {/*  onClick={() => handleClickViewDetail(REGISTER_DETAIL_ID.FINANCE_OPTIMIZE)}*/}
                {/*  background={'linear-gradient(90deg, #214081 -1.3%, #23B04E 393.97%)'}>*/}
                {/*  XEM CHI TIẾT*/}
                {/*</ButtonFinance>*/}
              </ButtonFinanceWrapper>
            </FinanceIntroItem>
          </FinanceIntroCol4>
        )
    }
  }


  return (
    financeData && (
      <FinanceIntroWrapper>
        <CircleBackground padding={'32px 0 48px 0'}>
          <Container>
            <Row gutter={renderGutter()} justify={'center'} align={'stretch'}>
              {renderByLength(financeData?.financialStationInformation?.informationList)}
            </Row>
            <FinanceTextGradientWrapper>
              <DangerouslySetInnerHtml html={financeData?.financialStationInformation?.commonDescription} />
            </FinanceTextGradientWrapper>
          </Container>
          {financeData?.registerButton?.show && (
            <ButtonGradientWrapper margin={'24px 0 0 0'}>
              <ButtonGradient onClick={handleClickRegister}>{financeData?.registerButton?.buttonText}</ButtonGradient>
            </ButtonGradientWrapper>
          )}
        </CircleBackground>

        {/*<Modal open={openModal} footer={null} onCancel={handleCloseModal} width={'80%'} title={''} style={{ top: 70 }}>*/}
        {/*  <ScrollHeightBase height={'calc(100vh - 160px)'}>*/}
        {/*    <TextGradientWrapper>*/}
        {/*      <TextGradient>Đua "TOP" giao dịch qua QR - Hoàn tiền triệu mỗi tháng</TextGradient>*/}
        {/*    </TextGradientWrapper>*/}
        {/*    <CenterDiv>*/}
        {/*      <img src={IMAGES.EVENT_1} alt={'event1'} />*/}
        {/*    </CenterDiv>*/}
        {/*    <CampaignContentText>*/}
        {/*      Từ nay đến hết 31/01/2025, VPBank dành tặng kho giải thưởng với tổng giá trị tới 04 tỷ đồng cho các Khách*/}
        {/*      hàng thường xuyên có giao dịch nhận tiền qua mã QR.*/}
        {/*      <br />*/}
        {/*      Cụ thể, dựa trên số lượng giao dịch thỏa điều kiện, Khách hàng sẽ nhận được các eVoucher hoàn tiền với giá*/}
        {/*      trị hàng triệu đồng. Giải thưởng mỗi tháng VPBank dành tặng Khách hàng như sau:*/}
        {/*      <br />*/}
        {/*      - Tặng eVoucher 500.000đ cho Top 10 khách hàng có nhiều giao dịch nhận tiền qua mã QR nhất trong tháng.*/}
        {/*      <br />*/}
        {/*      - Tặng ngay loạt eVoucher (*) với tổng giá trị đến 370.000đ khi nhận tiền qua mã QR đạt các mốc lần lượt:*/}
        {/*      10, 30, 50 & 100 giao dịch trong tháng. Khách hàng đạt đủ điều kiện ở mốc nào sẽ nhận thưởng ở mốc đó.*/}
        {/*      <br />*/}
        {/*      - Tặng thêm eVoucher 300.000đ khi lắp máy POS VPBank trong thời gian diễn ra chương trình. (*) Số lượng*/}
        {/*      evoucher có hạn & ưu tiên cho các khách hàng sử dụng nhanh nhất*/}
        {/*      <br />*/}
        {/*      Bên cạnh ưu đãi tặng eVoucher khi gia tăng giao dịch nhận tiền qua mã QR, Khách hàng còn nhận được các quyền*/}
        {/*      lợi hấp dẫn hỗ trợ việc kinh doanh hiệu quả & tiện lợi hơn:*/}
        {/*      <br />*/}
        {/*      - MIỄN PHÍ sử dụng Gói Giải pháp quản trị doanh số ShopQR trên VPBank NEO*/}
        {/*      <br />*/}
        {/*      - TẶNG bộ QR trưng bày miễn phí lần đầu, đăng ký qua VPBank NEO*/}
        {/*      <br />*/}
        {/*      - MIỄN PHÍ lắp máy POS, cung cấp da dạng tiện ích thanh toán cho cửa hàng*/}
        {/*      <br />*/}
        {/*      - Miễn phí 1 năm quản lý dịch vụ thanh toán của Tap2Phone - Ứng dụng thanh toán biến điện thoại thành*/}
        {/*      smartPOS*/}
        {/*      <br />*/}
        {/*      Để biết thêm chi tiết, Quý khách vui lòng liên hệ hotline 1900 54 54 15 (dành cho Khách hàng tiêu chuẩn) /*/}
        {/*      1800 54 54 15 (dành cho Khách hàng ưu tiên).*/}
        {/*      <br />*/}
        {/*    </CampaignContentText>*/}
        {/*    <ButtonGradientWrapper margin={'24px 0 0 0'}>*/}
        {/*      <ButtonGradient onClick={handleClickRegister}>ĐĂNG KÝ THAM GIA</ButtonGradient>*/}
        {/*    </ButtonGradientWrapper>*/}
        {/*  </ScrollHeightBase>*/}
        {/*</Modal>*/}
      </FinanceIntroWrapper>
    )
  )
}

export default FinanceIntro
